import React, { useState } from 'react';
import Dropdown from '~/app/common/Dropdown';
import Icon from '~/app/common/Icon';
import ConfirmationMenu from '~/app/common/ConfirmationMenu';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export interface ItemRowMenuProps<T> {
  item: T
  onEdit?: (item: T) => void
  onRemove: (item: T) => void
  confirmationText: string
}

export type ItemRowMenuComponent = <T>(props: ItemRowMenuProps<T>) => React.ReactElement;

const ItemRowMenu: ItemRowMenuComponent = ({ item, onEdit, onRemove, confirmationText }) => {
  const { t } = useTranslation('parts');
  const [isRemoveConfirmOpen, setIsRemoveConfirmOpen] = useState(false);

  return (
    <>
      <Dropdown icon={null} position="bottom left" closeOnClick>
        <Dropdown.Trigger>
          <button type="button" className={classes['row-menu-trigger']} aria-label="Actions">
            <Icon name="more_vert" size={20} />
          </button>
        </Dropdown.Trigger>
        <Dropdown.Content>
          <ul className={classes['row-menu']}>
            {onEdit && (
              <li onClick={() => onEdit(item)}>
                <Icon className={classes['row-menu-icon']} name="edit" />
                {t('edit')}
              </li>
            )}
            <li className={classes['row-menu-delete']} onClick={() => setIsRemoveConfirmOpen(true)}>
              <Icon className={classes['row-menu-icon']} name="delete" />
              {t('remove')}
            </li>
          </ul>
        </Dropdown.Content>
      </Dropdown>
      <ConfirmationMenu
        isOpen={isRemoveConfirmOpen}
        onConfirm={() => {
          setIsRemoveConfirmOpen(false);
          onRemove(item);
        }}
        onCancel={() => setIsRemoveConfirmOpen(false)}
        confirmationText={confirmationText}
      />
    </>
  );
};

export default ItemRowMenu;
